import React, { useState, useEffect }from "react";
import { useDispatch } from "react-redux";

import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { FileUpload } from 'primereact/fileupload';
import { TextInputField, Button } from "../helpers";
import ChipsField from "../helpers/ChipsField";

import FileViewAndRemove from "./FileViewAndRemove";

import { raiseToast } from "../services/redux/reducers/toast/toast";

import { convertURLToDataURI, getUploadedFileObj, validateInputs } from "../utils";
import { sendEmailValidationSchema } from "../validation/sendEmailValidation";

import "./index.css";
import Loading from "./Loading";


const SendEmail = (props) =>{
    const { emailDetailsObj, handleSendMail, setEmailDetailsObj } = props

    const [subject, setEmailSub] = useState(emailDetailsObj.subject)
    const [message, setText] = useState("")
    const [cc, setEmailCc] = useState([])
    const [uploadFile, setUploadedFiles] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    
    useEffect(() => {
        setEmailSub(emailDetailsObj.subject);
        setText(emailDetailsObj.message)
        if (emailDetailsObj.cc){
            setEmailCc(emailDetailsObj.cc)
        }

        fetchDataUris()
    }, [emailDetailsObj.subject, emailDetailsObj.attachments, emailDetailsObj.cc])

    const [formErrors, setFormErrors] = useState({})
    const dispatch = useDispatch()

    const fetchDataUris = async () => {
        if(emailDetailsObj.attachments?.length > 0){
            const formattedAttachments = []

            await Promise.all(emailDetailsObj.attachments.map(async eachAttachment => {
                if(eachAttachment.url){
                    formattedAttachments.push({
                        file: null,
                        file_name: eachAttachment.file_name,
                        url: eachAttachment.url,
                        fileUrl: eachAttachment.url,
                        data_uri: await convertURLToDataURI(eachAttachment.url),
                        documentName: "",
                        fileName: eachAttachment.file_name,
                        dataURI: await convertURLToDataURI(eachAttachment.url),
                        name: eachAttachment.file_name,
        
                        /*url: eachFile.objectURL,
                        objectURL: eachFile.objectURL*/
                    })
                }
            }))

            setUploadedFiles(formattedAttachments)
        }
    }

    const handleSendEmail = async () => {
        const emailObj = { 
            to: emailDetailsObj.to, 
            from: emailDetailsObj.from, 
            subject, message, 
            kam: emailDetailsObj.kam, 
            cc, 
            attachments: emailDetailsObj.attachments,
            clientId: emailDetailsObj.clientId,
            refreshToken: emailDetailsObj.refreshToken,
            clientSecret: emailDetailsObj.clientSecret
        }
        const validationRespose = await validateInputs(sendEmailValidationSchema, emailObj)
        const ccMails = cc.length 

        if(validationRespose.error){
            if (ccMails > 0){
                cc.map((item, index) => {
                    const key = `cc[${index}]`
                    const errMsg = validationRespose.error[key]
                    if(errMsg !== undefined){
                        return validationRespose.error.cc = errMsg
                    }
                })
            }
            
            setFormErrors(validationRespose.error)
        }else{
            emailObj.cc = validationRespose.result.cc
            setFormErrors({})
            setEmailCc(validationRespose.result.cc)
            if (uploadFile.length > 0) {
                emailObj.attachments = uploadFile
                sendEmailAndUpdateState(emailObj)
            }
            else {
                emailObj.attachments = []
                sendEmailAndUpdateState(emailObj)
            }
        }
    }

    const fileUploadHandler = async ({ files, options }) => {

        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: "DISPATCH_TRACKING" })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        setUploadedFiles((prevFiles) => [...prevFiles, ...fileArr])
    }

    const sendEmailAndUpdateState = async (emailObj) => {
        if(window.confirm("Are you sure you want to send the mail?")){
            setIsLoading(true)
            const response = await handleSendMail(emailObj)
            if (response?.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Send Email', detail: "Email was not sent"}))
            } 
            else {
                props.onHide()
                setEmailCc([])
                setUploadedFiles([])
                if(setEmailDetailsObj){
                    setEmailDetailsObj({})
                }
                setIsLoading(false)
            }
        }
    }
    
    const handleCancel = () => {
        setEmailCc([])
        setText("")
        setFormErrors({})
        if(setEmailDetailsObj){
            setEmailDetailsObj({})
        }
        props.onHide()
    }

    const footerContent = () => {
        return(
            <div>
                <Button label="Cancel" severity="danger" outlined onClick={handleCancel} />
                <Button label="Send Mail" severity="" outlined onClick={handleSendEmail} applyThrottle={true} />
            </div>
        )
    }
    
    const handleRemoveClick = (file) => {
        if(window.confirm("Do you want to remove file")){
            setUploadedFiles((prevFiles) => prevFiles.filter(eachFile => eachFile !== file))
        }
    }

    const handleOnBlurCCEmail = (e) => {
        const inputValue = e.target.value.trim();

        if (inputValue) {
            let emails = inputValue.split(/[,\s;]+/).filter(Boolean)
            let uniqueEmails = emails.filter(email => !cc.includes(email))

            if (uniqueEmails.length > 0) {
                setEmailCc([...cc, ...uniqueEmails])
            }
        }

        e.target.value = ''
    }

    const handleKeyDown = (e) => {
        const separators = [',', ';', ' ', '/']

        if (separators.includes(e.key)) {
            e.preventDefault()
            const inputValue = e.target.value.trim()

            if (inputValue && !cc.includes(inputValue)) {
                setEmailCc([...cc, inputValue])
            }

            e.target.value = ''
        }
    }

    const isOutlookMailCheck = (email) => {
        const outlookDomains = ['outlook.com', 'hotmail.com', 'live.com', 'office365.com', 'outlook.in']

        const domain = email.split('@')[1]?.toLowerCase()
        return outlookDomains.includes(domain)
    }

    const isOutlookMail = emailDetailsObj.from ? isOutlookMailCheck(emailDetailsObj.from) : false
      
    return(
        <>
            <Dialog className="send-email-modal" header="Send Email" visible={props.visible} footer={footerContent} style={{ }} onHide={() => {props.onHide(); setUploadedFiles([])}}>
                <div className={`grid ${isOutlookMail ? 'outlook-watermark' : ''}`}>
                    <div className="flex flex-column col-6">
                        <TextInputField name="to" labelText="To" value={emailDetailsObj.to} errorMessage={formErrors.to} disabled/>
                    </div>
                    <div className="flex flex-column col-6">
                        <TextInputField name="from" labelText="from" value={emailDetailsObj.from} errorMessage={formErrors.from} disabled/>
                    </div>
                    <div className="flex flex-column col-4">
                        <TextInputField name="" labelText="Kam" value={emailDetailsObj.kam} errorMessage={formErrors.kam} disabled/>
                    </div>
                    <div className="flex flex-column col-8">
                        <ChipsField name="" labelText="Cc" onChange={(e) => setEmailCc(e.target.value)} value={cc} onBlur={handleOnBlurCCEmail} onKeyDown={handleKeyDown} errorMessage={formErrors.cc} />
                    </div>
                    <div className="flex flex-column col-12">
                        <TextInputField name="" labelText="Subject" onChange={(e) => setEmailSub(e.target.value)} value={subject} errorMessage={formErrors.subject} />
                    </div>
                    <div className="flex flex-column col-12 mb-2">
                        <Editor name="" labelText="Message" style={{ height: '250px' }} onTextChange={(e) => setText(e.htmlValue)} value={message}/>
                        { formErrors.message && <small className='p-error' style={{ fontSize: 'x-small', marginTop: '0.25rem' }}>{formErrors.message}</small> }
                    </div>
                    <div className="flex flex-column col-10">
                        {uploadFile.map((file, index) => (
                            <div className="flex" key={index} style={{marginBottom: "3px"}}>
                                <span className="mr-1">{index + 1}. {file.file_name} </span>
                                <FileViewAndRemove doc={file} docName={file.file_name} />
                                <a style={{ color: "red", margin: "2px", cursor: "pointer", fontSize: "13px" }} className="ml-1" onClick={() => handleRemoveClick(file)}> Remove </a>
                            </div>
                        ))}
                        <FileUpload mode="basic" name="" accept="image/pdf/*" customUpload  auto chooseLabel="Upload File" multiple={true} uploadHandler={(files) => fileUploadHandler(files)}/>
                    </div>
                </div>
            </Dialog>
            <Loading visible={isLoading} />
        </>
    )
}

export default SendEmail;